import { IPageOf } from '@howdeniberia/core-front';
import { Observable } from 'rxjs';
import { IMapRating, IMapRatingFilter } from 'src/app/core/models/api';

export abstract class IMapRatingService {
  abstract search(request: IMapRatingFilter): Observable<IPageOf<IMapRating>>;
  abstract downloadExcel(request: IMapRatingFilter): Observable<Blob>;
}
